import { createSlice } from "@reduxjs/toolkit";

import { getLanguagesRedux } from "./languages.asyncActions";

const initialState = {
    message: "",
    status: "idle",
    isReqTrue: true,
    languages: [],
};

export const languagesSlice = createSlice({
    name: "languagesState",
    initialState,
    reducers: {
        setLangTrue: (state, action) => {
            state.isReqTrue = true;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getLanguagesRedux.pending, (state) => {
                state.status = "loading";
            })
            .addCase(getLanguagesRedux.fulfilled, (state, action) => {
                state.status = "success";
                state.languages = action.payload.data && action.payload.data;
                state.isReqTrue = false;
            })
            .addCase(getLanguagesRedux.rejected, (state, action) => {
                state.getLanguages.status = "failed";
                state.getLanguages.message =
                    action.payload.message && action.payload.message;
                state.isReqTrue = false;
            });
    },
});

export default languagesSlice.reducer;
export const { setLangTrue } = languagesSlice.actions;
